// action types
export const TERMINAL_SET_LINES = "terminalSetLines";
export const TERMINAL_APPEND_LINE = "terminalAppendLine";

// mutation types
export const SET_TERMINAL_DEVICE = "setTerminalDevice";
export const TERMINAL_ADD_LINE = "terminalAddLine";
export const SET_TERMINAL_CONTENT = "setTerminalLines";

export default {
  state: {
    device: {},
    lines: []
  },
  getters: {
    terminalDevice(state) {
      return state.device;
    },
    terminalLines(state) {
      return state.lines;
    }
  },
  actions: {
    [SET_TERMINAL_DEVICE](state, device) {
      state.commit(SET_TERMINAL_DEVICE, device);
    },
    [SET_TERMINAL_CONTENT](state, payload) {
      state.commit(TERMINAL_SET_LINES, payload);
    },
    [TERMINAL_ADD_LINE](state, payload) {
      payload.time = new Date().toLocaleTimeString();
      state.commit(TERMINAL_APPEND_LINE, payload);
    }
  },
  mutations: {
    [SET_TERMINAL_DEVICE](state, device) {
      state.device = device;
    },
    [TERMINAL_SET_LINES](state, payload) {
      state.lines = payload;
    },
    [TERMINAL_APPEND_LINE](state, payload) {
      state.lines = [...state.lines, payload];
    }
  }
};
